// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_wrU8G","logo":"index_logo_1-D7S"};